import { Alert, Button, Input, Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../../context/env-context';
import { useHandlers } from '../../../../context/page-context';
import type { CreatedAPIKey } from '../../types';

export function ShowKeyModal({
  isOpen,
  closeModal,
  keyData,
}: {
  isOpen: boolean;
  closeModal: () => void;
  keyData: CreatedAPIKey | undefined;
}) {
  const env = useEnv();
  const { notificationHandler } = useHandlers();

  async function copy(data: string | undefined) {
    if (data) {
      return await navigator.clipboard.writeText(data).catch(() => {
        notificationHandler.notify(t('notifications:titles.error'), t('errors:generic'), 'error');
      });
    }
  }

  const KEY_ROWS = [
    {
      name: 'Site ID',
      value: env.team.slugged_name,
    },
    {
      name: 'Client ID',
      value: keyData?.client_id,
    },
    {
      name: 'Client Secret',
      value: keyData?.client_secret,
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      secondaryAction={{
        text: t('features:api_settings.components.modals.create_key.close'),
        onClick: closeModal,
      }}
    >
      <Modal.Header>{t('features:api_settings.components.modals.show_key.header')}</Modal.Header>
      <Modal.Body>
        <Alert headingLevel="span" variant="warning">
          {t('features:api_settings.components.modals.show_key.warning')}
        </Alert>

        {KEY_ROWS.map((row) => (
          <span className="pt-2" key={row.name}>
            <Text>{row.name}</Text>
            <span className="flex gap-2">
              <div className="grow">
                <Input value={row.value} disabled={true} />
              </div>
              <Button variant="secondary" icon="copy" onClick={async () => await copy(row.value)}>
                {t('buttons:copy')}
              </Button>
            </span>
          </span>
        ))}
      </Modal.Body>
    </Modal>
  );
}
